import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  GridProps,
  Typography,
  TypographyProps,
} from '@mui/material';

import type { TChecklistItem } from '@/types/common';

type TAmenitiesLevelProps = GridProps & {
  items: TChecklistItem[];
  values: Record<string, boolean>;
  setValue: (prop: string, value: boolean) => void;
  disabled?: boolean;
  parent?: string;
};

export const AmenitiesLevel = ({
  items,
  values,
  setValue,
  disabled,
  parent,
  ...gridProps
}: TAmenitiesLevelProps) => {
  const labelProps: TypographyProps = {
    color: disabled ? 'text.disabled' : 'text.primary',
    variant: parent ? 'body2' : 'body1',
  };

  const renderField = ({ name, label, nested }: TChecklistItem) => {
    const value = values[name] || false;

    return (
      <Grid display="block" key={name} {...gridProps} item>
        <FormControl margin="none">
          <FormControlLabel
            checked={value}
            onChange={(event, checked) => setValue(name, checked)}
            label={<Typography {...labelProps}>{label}</Typography>}
            control={<Checkbox />}
            disabled={disabled}
          />
        </FormControl>

        {nested && (
          <Grid spacing={3} paddingTop={3} paddingLeft={5} container>
            <AmenitiesLevel
              items={nested}
              values={values}
              setValue={setValue}
              disabled={disabled || !value}
              parent={name}
              xs={6}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  return <>{items.map(renderField)}</>;
};
